import { Toast } from 'mint-ui';
function toast(message) {
    Toast({
        message: message,
        position: 'middle',
        duration: 3000
    });
}
export default toast